import React from 'react';

import Slider from '../Slider/Slider';

const Home = () => {
    return (
        <div>
         <Slider></Slider>
         <div className="text-center">
         <h1>Product Uploading</h1>
  <div className="spinner-border" role="status">
    <span className="visually-hidden">Loading...</span>

  </div>

</div>
        </div>
    );
};

export default Home;